/**
 * What the live socket does after it closes, by the close code `server/src/live.ts`
 * sends: 4401 is a session the server refused, so reconnecting would be refused
 * again for ever; 1013 is the session lookup hanging, which a quick retry only adds
 * to; anything else (1011 a failed lookup, 1006 a dropped network, a deploy) backs
 * off from a second.
 */
export const CLOSE_BAD_SESSION = 4401;
export const CLOSE_LOOKUP_HUNG = 1013;

/** Down this long and the app says live updates are off (the poll carries on). */
export const LIVE_OFF_AFTER_MS = 20_000;

const MAX_DELAY_MS = 30_000;

/** Milliseconds before reconnect attempt `retry` (1-based), or null for never. */
export function reconnectDelay(code: number, retry: number): number | null {
  if (code === CLOSE_BAD_SESSION) return null;
  const base = code === CLOSE_LOOKUP_HUNG ? 5_000 : 1_000;
  return Math.min(base * 2 ** Math.min(Math.max(retry, 1), 5), MAX_DELAY_MS);
}
